import * as types from '../../types/workplansComments';

export const startFetchingComments = (visitId, locationId) => ({
  type: types.WORKPLAN_COMMENTS_FETCH_STARTED,
  payload: { visitId, locationId }
});
export const completeFetchingComments = (entities, order) => ({
  type: types.WORKPLAN_COMMENTS_FETCH_COMPLETED,
  payload: {
    entities,
    order
  }
});
export const failFetchingComments = (error = { errorMessage: 'Error', errorNumber: 404 }) => ({
  type: types.WORKPLAN_COMMENTS_FETCH_FAILED,
  payload: {
    error //error:{errorMessage:'Error', errorNumber:400}
  }
});

export const startAddingComment = (comment) => ({
  type: types.WORKPLAN_COMMENT_ADD_STARTED,
  payload: comment
});
export const completeAddingComment = (oldId, comment) => ({
  type: types.WORKPLAN_COMMENT_ADD_COMPLETED,
  payload: { oldId, comment }
});
export const failAddingComment = (oldId, error) => ({
  type: types.WORKPLAN_COMMENT_ADD_FAILED,
  payload: {
    oldId,
    error
  }
});

export const startRemovingComment = (commentId, visitId, locationId) => ({
  type: types.WORKPLAN_COMMENT_REMOVE_STARTED,
  payload: {
    commentId,
    visitId,
    locationId
  }
});
export const completeRemovingComment = (commentId) => ({
  type: types.WORKPLAN_COMMENT_REMOVE_COMPLETED,
  payload: {
    commentId
  }
});
export const failRemovingComment = (commentId, error) => ({
  type: types.WORKPLAN_COMMENT_REMOVE_FAILED,
  payload: {
    commentId,
    error
  }
});
